export default __webpack_public_path__ + "static/media/pricing3.ea502163.png";